import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import { Button } from '../ui/button';
import { Lock, Save } from 'lucide-react';
import PasswordInput from '../common/PasswordInput';

export interface PasswordFormErrors {
  currentPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
}

interface ChangePasswordProps {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  passwordErrors: PasswordFormErrors;
  isSaving: boolean;
  onCurrentPasswordChange: (value: string) => void;
  onNewPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  onSubmit: () => void;
  isPasswordFormValid: () => boolean;
  description?: string;
}

const ChangePassword = ({
  currentPassword,
  newPassword,
  confirmPassword,
  passwordErrors,
  isSaving,
  onCurrentPasswordChange,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
  isPasswordFormValid,
  description,
}: ChangePasswordProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2 text-base sm:text-lg">
          <Lock className="h-5 w-5 flex-shrink-0" />
          <span>Change Password</span>
        </CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent className="space-y-4">
        <PasswordInput
          id="currentPassword"
          name="currentPassword"
          label="Current Password"
          value={currentPassword}
          onChange={e => onCurrentPasswordChange(e.target.value)}
          error={passwordErrors.currentPassword}
          showToggle={true}
        />
        <PasswordInput
          id="newPassword"
          name="newPassword"
          label="New Password"
          value={newPassword}
          onChange={e => onNewPasswordChange(e.target.value)}
          error={passwordErrors.newPassword}
          showToggle={true}
        />
        <PasswordInput
          id="confirmPassword"
          name="confirmPassword"
          label="Confirm New Password"
          value={confirmPassword}
          onChange={e => onConfirmPasswordChange(e.target.value)}
          error={passwordErrors.confirmPassword}
          showToggle={true}
        />
        <div className="flex justify-center sm:justify-end">
          <Button
            onClick={onSubmit}
            disabled={!isPasswordFormValid() || isSaving}
          >
            {isSaving ? (
              <div className="flex items-center space-x-2">
                <div className="animate-spin h-4 w-4 border-2 border-current border-t-transparent rounded-full" />
                <span>Updating...</span>
              </div>
            ) : (
              <div className="flex items-center space-x-2">
                <Save className="h-4 w-4" />
                <span>Update Password</span>
              </div>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ChangePassword;
